import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RadioPicker, RadioOption } from '../../../FlowConfigurationInputs/RadioPicker/RadioPicker';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Copy({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const [tab, setTab] = useState(action.fields.tab?.value ? action.fields.tab.value : 'row');
    const [columnTab, setColumnTab] = useState(action.fields.columnTab?.value ? action.fields.columnTab.value : 'index');
    const label = 'CONTENT.CONFIGURATION-FORM.EXCEL.COPY.';
    useEffect(() => {
        // Assign initial values
        if (!action.fields.tab) {
            action.fields.tab = { value: 'row' };
            setTab('row');
        } else {
            setTab(action.fields.tab.value);
        }
        if (!action.fields.columnTab) {
            action.fields.columnTab = { value: 'index' };
            setColumnTab('index');
        } else {
            setColumnTab(action.fields.columnTab.value);
        }
    }, [action.id]);
    // Handle tab change
    const handleClick = (e) => {
        let value = e.target.value;
        action.fields.tab = { value };
        if (value === 'column') {
            delete action.fields.rowNumber;
        }
        setTab(value);

        if (value === 'row') {
            delete action.fields.columnName;
            delete action.fields.columnLetter;
            delete action.fields.columnTab;
        } else {
            action.fields.columnTab = { value: 'index' };
            action.fields.columnLetter = { value: '', htmlValue: '' };
            delete action.fields.columnName;
            setColumnTab('index');
        }
    }
    const handleChange = (e) => {
        let value = e.target.value;
        action.fields.columnTab = { value };
        if (value === 'index') {
            delete action.fields.columnName;
        } else {
            delete action.fields.columnLetter;
        }
        setColumnTab(value);
    }
    return (
        <>
            <div className="conf-field-container">
                <div className="conf-field-container">
                    <FieldLabel name={t(label + 'EXCEL-SOURCE')} is_required />
                    <VariablePicker action={action} inputName="excelSource" variables={variables}
                        setOpenVariable={setOpenVariable} filter="data table" isRequired hideRequired />
                    <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
                </div>
            </div>
            <div className="conf-field-container condition-tabs">
                <button className={`f-s-11 ${tab === 'row' ? 'condition-active' : ''}`} value="row" onClick={handleClick}>
                    {t(label + 'ROW')}
                </button>
                <button className={`f-s-11 ${tab === 'column' ? 'condition-active' : ''}`} value="column" onClick={handleClick}>
                    {t(label + 'COLUMN')}
                </button>
                <button className={`f-s-11 ${tab === 'cell' ? 'condition-active' : ''}`} value="cell" onClick={handleClick}>
                    {t(label + 'CELL')}
                </button>
            </div>
            {tab === 'cell' ? <>
                <div className="conf-field-container">
                    <FieldLabel name={t(label + 'CELL-ROW')} is_required />
                    <TextInput action={action} inputName="rowNumber" variables={variables}
                        setOpenVariable={setOpenVariable} isRequired fieldType="string-single-row" displayName={t(label + 'CELL-ROW')} hideRequired />
                </div>
                <div className="conf-field-container">
                    <RadioPicker value={columnTab} onChange={handleChange}>
                        <RadioOption value="index">
                            <div className="conf-field-container">
                                <FieldLabel name={t(label + 'CELL-COLUMN')} is_required={columnTab === 'index'} />
                                <TextInput action={action} inputName="columnLetter" variables={variables}
                                    setOpenVariable={setOpenVariable} disabled={columnTab !== 'index'}
                                    isRequired={columnTab === 'index'} fieldType="string-single-column" displayName={t(label + 'CELL-COLUMN')} hideRequired />
                                <em className="conf-field-desc">{t(label + 'COLUMN-INDEX-EG')}</em>
                            </div>
                        </RadioOption>
                        <RadioOption value="name">
                            <div className="conf-field-container">
                                <FieldLabel name={t(label + 'COLUMN-NAME')} is_required={columnTab === 'name'} />
                                <TextInput action={action} inputName="columnName" variables={variables}
                                    setOpenVariable={setOpenVariable} disabled={columnTab !== 'name'}
                                    isRequired={columnTab === 'name'} fieldType="string" displayName={t(label + 'COLUMN-NAME')} hideRequired />
                                <em className="conf-field-desc">{t(label + 'COLUMN-NAME-EG')}</em>
                            </div>
                        </RadioOption>
                    </RadioPicker>
                </div>
            </> :
                tab === 'column' ?
                    <div className="conf-field-container">
                        <RadioPicker value={columnTab} onChange={handleChange}>
                            <RadioOption value="index">
                                <div className="conf-field-container">
                                    <FieldLabel name={t(label + 'CELL-COLUMN')} is_required={columnTab === 'index'} />
                                    <TextInput action={action} inputName="columnLetter" variables={variables}
                                        setOpenVariable={setOpenVariable} disabled={columnTab !== 'index'}
                                        isRequired={columnTab === 'index'} fieldType="string-single-column" displayName={t(label + 'CELL-COLUMN')} hideRequired />
                                    <em className="conf-field-desc">{t(label + 'COLUMN-INDEX-EG')}</em>
                                </div>
                            </RadioOption>
                            <RadioOption value="name" active={columnTab === 'name'}>
                                <div className="conf-field-container">
                                    <FieldLabel name={t(label + 'COLUMN-NAME')} is_required={columnTab === 'name'} />
                                    <TextInput action={action} inputName="columnName" variables={variables}
                                        setOpenVariable={setOpenVariable} disabled={columnTab !== 'name'}
                                        isRequired={columnTab === 'name'} fieldType="string" displayName={t(label + 'COLUMN-NAME')} hideRequired />
                                    <em className="conf-field-desc">{t(label + 'COLUMN-NAME-EG')}</em>
                                </div>
                            </RadioOption>
                        </RadioPicker>
                    </div> :
                    <div className="conf-field-container">
                        <FieldLabel name={t(label + 'CELL-ROW')} is_required />
                        <TextInput action={action} inputName="rowNumber" variables={variables}
                            setOpenVariable={setOpenVariable} isRequired fieldType='string-single-row' displayName={t(label + 'CELL-ROW')} hideRequired />
                        <em className="conf-field-desc">{t(label + 'ROW-NUMBER-EG')}</em>
                    </div>
            }
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'ASSIGN-SOURCE')} is_required />
                <VariablePicker action={action} inputName="copiedValue" variables={variables}
                    setOpenVariable={setOpenVariable}
                    filter={tab === 'cell' ? 'string' : 'array'} isRequired hideRequired />
                <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: tab === 'cell' ? 'string' : 'array' })}</em></small>
            </div>
        </>
    );
}
export default Copy;